"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = reducer;
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const initialState = {
    showLoader: false,
    impersonationInput: "",
    showImpersonationError: false
};
function reducer(state = initialState, action) {
    switch (action.type) {
        case "debug/SET-LOADER":
            return Object.assign(Object.assign({}, state), { showLoader: action.loader });
        case "debug/SET-IMPERSONATION-INPUT":
            return Object.assign(Object.assign({}, state), { impersonationInput: action.input });
        case "debug/SET-IMPERSONATION-ERROR":
            return Object.assign(Object.assign({}, state), { showImpersonationError: action.showError });
        case "global-actions/REQUEST_OPEN_TAB":
            return state;
        default:
            (0, ts_exhaustive_check_1.exhaustiveCheck)(action);
            return state;
    }
}
//# sourceMappingURL=reducer.js.map